import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PDFUploadTest from '@/components/installations/pdf-upload-test';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Link } from 'wouter';

export default function PDFTestPage() {
  return (
    <div className="container py-8">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">PDF Upload Testing</h1>
        <Link href="/installations">
          <Button variant="outline">Back to Installations</Button>
        </Link>
      </div>

      <Tabs defaultValue="upload" className="space-y-6">
        <TabsList>
          <TabsTrigger value="upload">PDF Upload Test</TabsTrigger>
          <TabsTrigger value="info">Debugging Info</TabsTrigger>
        </TabsList>

        <TabsContent value="upload" className="space-y-6">
          <PDFUploadTest />
        </TabsContent>

        <TabsContent value="info">
          <Card>
            <CardHeader>
              <CardTitle>Document Upload Debugging Information</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="text-lg font-medium mb-2">PDF Upload Process</h3>
                <ol className="list-decimal pl-5 space-y-2">
                  <li>Select a PDF file using the file input</li>
                  <li>
                    The file is read as a Data URL with <code>FileReader.readAsDataURL()</code>
                  </li>
                  <li>The file's metadata (name, type, size) is stored alongside the Data URL</li>
                  <li>
                    When "Test Upload" is clicked, the data is sent to a dedicated test endpoint
                  </li>
                  <li>The server-side endpoint logs detailed information about the process</li>
                  <li>The server appends the PDF data to the installation's document array</li>
                  <li>The response indicates success or failure with detailed error information</li>
                </ol>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Data Structure</h3>
                <p>Each document is stored with the following properties:</p>
                <pre className="bg-muted p-4 rounded-md text-sm overflow-auto">
                  {`{
  data: "data:application/pdf;base64,ENCODED_DATA_HERE...",
  name: "example-document.pdf",
  type: "application/pdf",
  size: 12345  // size in bytes
}`}
                </pre>
              </div>

              <div>
                <h3 className="text-lg font-medium mb-2">Troubleshooting Issues</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Check browser console for errors during file selection or upload</li>
                  <li>Examine server logs for detailed processing information</li>
                  <li>Verify the PDF is valid and not corrupted</li>
                  <li>Ensure filename metadata is being properly attached</li>
                  <li>Check for array handling issues in the database operations</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
